import { Injector } from '@angular/core';
import { getBrowserLang, TranslocoService } from '@jsverse/transloco';
import { LOCATION_INITIALIZED } from '@angular/common';

export function appInitializerFactory(translateService: TranslocoService, injector: Injector) {
  return () =>
    new Promise<any>((resolve: any) => {
      const locationInitialized = injector.get(LOCATION_INITIALIZED, Promise.resolve(null));
      locationInitialized.then(_ => {
        const supportedLangs = translateService.getAvailableLangs().map(lang => lang.toString());
        const defaultLang = translateService.getDefaultLang();

        if (localStorage.getItem('language') === null) {
          let localStorageLang = defaultLang;
          const browserLang = getBrowserLang();
          if (browserLang) {
            if (supportedLangs.includes(browserLang)) {
              localStorageLang = browserLang;
            }
          }
          const language: string = localStorageLang === 'gb' ? 'en' : localStorageLang;
          localStorage.setItem('language', language);
        }

        let langToSet = localStorage.getItem('language');
        langToSet = langToSet == null ? defaultLang : langToSet;
        translateService.setActiveLang(langToSet);
        translateService.load(langToSet).subscribe({
          next: () => {},
          error: _ => {
            console.error(`Problem with ${langToSet} language initialization.`);
          },
          complete: () => {
            resolve(null);
          },
        });
      });
    });
}
